import { device } from 'app/ui-components/breakpoints';
import { playFocus } from 'app/ui-components/utils.styles';
import styled from 'styled-components';
import { regularWhite } from 'app/ui-components/design-tokens';
import SvgIcon from 'app/ui-components/SvgIcon/SvgIcon';

export const StyledTopBarVariantNoWrap = styled.span`
    white-space: nowrap;
`;

export const StyledTopBarVariantLink = styled.a`
    color: ${regularWhite};
    display: inline-block;
    text-decoration: underline;
    ${playFocus()}
`;

export const StyledTopBarVariantIcon = styled(SvgIcon)`
    margin-right: 3px;
    width: 15px;

    @media ${device.GteSmall} {
        width: 20px;
        margin-right: 3px;
        margin-left: 3px;
    }
`;
